import CourseDesc from "@/components/CourseDesc/CourseDesc";
import CourseDescV2 from "@/components/CourseDesc/CourseDescV2";
import NewCourseDescV2 from "@/components/CourseDesc/NewCourseDescV2";
import MarketingCourseDescV2 from "@/components/CourseDesc/MarketingCourseDescV2";
import ErrorPage from "../ErrorPage/ErrorPage";
import React from "react";
import { useParams } from "react-router-dom";

const CourseDescPage = () => {
  const { id } = useParams();

  const availableCourses = ["101", "102", "103"];

  const renderComponent = () => {
    if (!availableCourses.includes(id)) {
      return <ErrorPage />;
    }

    switch (id) {
      case "101":
        return <CourseDescV2 />;
      case "102":
        return <NewCourseDescV2 />;
      case "103":
        return <MarketingCourseDescV2 />;
      default:
        return <ErrorPage />;
    }
  };

  return <div className="">{renderComponent()}</div>;
};

export default CourseDescPage;
